import styled from "styled-components";
import { colors } from "../../../theme/color";
import fipayFonts from "../../../theme";

export const PaymentLinkSideBarContainer = styled.div`
  height: 100vh;
  position: fixed;
  background-color: #ffffff;
  width: 14.2rem;
  z-index: 9999;
  @media only screen and (max-width: 767px) {
    border-right: 1px solid ${colors.general.brightGray};
    border-bottom: 1px solid ${colors.general.brightGray};
    border-left: 1px solid ${colors.general.brightGray};
    background: ${colors.White};
    box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
    width: 16.6875rem;
    top: 0%;
    left: 0%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 14.2rem;
    top: 0%;
    left: 0%;
    margin: 0;
  }
`;

export const ImageCon = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-left: 35px;
  @media only screen and (max-width: 767px) {
    margin: 1.19rem 0;
    padding: 0 3.5rem;
    align-content: center;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin: 1rem 0rem 0rem 1rem;
  }
`;
export const XIcon = styled.img`
  display: none;
  @media only screen and (max-width: 767px) {
    display: flex;
    width: 2rem;
    height: 2rem;
    align-self: center;
  }
`;
export const FipayLogo = styled.img`
  display: flex;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
export const FipayMobileLogo = styled.img`
  display: none;
  @media only screen and (max-width: 767px) {
    display: flex;
  }
`;
export const SideBarContainer = styled.div`
  padding-top: 30px;
  gap: 46px;
  // margin-left: 40px;
  @media only screen and (max-width: 767px) {
    margin: 0;
    padding: 1.5rem;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    padding: 1.5rem;
    margin: 0;
  }
`;

export const SideBarContent1 = styled.div`
  display: flex;
  padding-top: 20px;
  cursor: pointer;
  img {
    padding-left: 40px;
  }

  @media only screen and (max-width: 1024px) {
    img {
      padding-left: 14px;
    }
  }
`;

export const SideBarContent2 = styled.div`
  display: flex;
  padding-top: 20px;
  cursor: pointer;

  img {
    padding-left: 40px;
  }

  @media only screen and (max-width: 1024px) {
    margin-top: 0;
  }
`;

export const SideBarContent3 = styled.div`
  display: flex;
  padding-top: 20px;
  cursor: pointer;
  img {
    padding-left: 40px;
  }
`;

export const SideBarContent4 = styled.div`
  display: flex;
  padding-top: 20px;
  cursor: pointer;
  img {
    padding-left: 40px;
  }
`;

export const SideBarContent5 = styled.div`
  display: flex;
  padding-top: 20px;
  cursor: pointer;
  img {
    padding-left: 40px;
  }
`;

export const SideBarContent6 = styled.div`
  display: flex;
  padding-top: 20px;
  cursor: pointer;
  img {
    padding-left: 40px;
  }

  @media only screen and (max-width: 1024px) {
    padding-bottom: 0;
    img {
      padding-left: 14px;
    }
  }
`;

export const Span0 = styled.span`
  padding-left: 10px;
  color: ${colors.DARK_GRAY};
`;

export const Span = styled.span`
  padding-left: 10px;
  color: ${colors.DARK_GRAY};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body1};

  @media only screen and (max-width: 1024px) {
    /* padding-left: 0; */
    /* border: 2px solid red; */
  }
`;

export const Span7 = styled.span`
  padding-left: 10px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.DANGER};
`;

export const MainMenuText = styled.div`
  margin-left: 15px;
  padding-top: 40px;
  padding-left: 20px;
  @media only screen and (max-width: 767px) {
    margin: 0;
    padding: 0 3.5rem;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin: 0;
  }
`;

export const LogOutText = styled.div`
  position: absolute;
  bottom: 25px;
  margin-left: 45px;
  display: flex;
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
export const CloseButton = styled.div`
  position: absolute;
  top: 3%;
  right: 0;
`;
